const CUSTOM_CAKE_IDS = {
  // SIZE_GROUP_ID: 37,
  // SHAPE_GROUP_ID: 32,
  // FLAVOR_GROUP_ID: 31,
  // D3_GROUP_ID: 38,
  // GLITTER_GROUP_ID: 39,
  // RIBBON_GROUP_ID: 40,
  // MESSAGE_GROUP_ID: 41,
  // SIZE_5INCH_ID: 99,
  // SIZE_6INCH_ID: 100,
  // SIZE_8INCH_ID: 101,
  // SIZE_10INCH_ID: 118,
  // SHAPE_ROUND_ID: 85,
  // FLAVOR_CHOCOLATE_ID: 81,
  // FLAVOR_STRAWBERRY_ID: 82,
  // D3_0SHAPE_ID: 102,
  // D3_1SHAPE_ID: 108,
  // D3_2SHAPE_ID: 109,
  // D3_3SHAPE_ID: 110,
  // GLITTER_GOLDEN_ID: 105,
  // GLITTER_SILVER_ID: 111,
  // RIBBON_NO_ID: 104,
  // RIBBON_1PC_ID: 106,
  // RIBBON_2PC_ID: 112,
  // RIBBON_3PC_ID: 113,
  // RIBBON_4PC_ID: 114,
  // MESSAGE_PRINTING_ID: 115,

  SIZE_GROUP_ID: Number(process.env.REACT_APP_CC_SIZE_GROUP_ID),
  SHAPE_GROUP_ID: Number(process.env.REACT_APP_CC_SHAPE_GROUP_ID),
  LAYER_GROUP_ID: Number(process.env.REACT_APP_CC_LAYER_GROUP_ID),
  FLAVOR_GROUP_ID: Number(process.env.REACT_APP_CC_FLAVOR_GROUP_ID),
  D3_GROUP_ID: Number(process.env.REACT_APP_CC_3D_GROUP_ID),
  GLITTER_GROUP_ID: Number(process.env.REACT_APP_CC_GLITTER_GROUP_ID),
  RIBBON_GROUP_ID: Number(process.env.REACT_APP_CC_RIBBON_GROUP_ID),
  MESSAGE_GROUP_ID: Number(process.env.REACT_APP_CC_MESSAGE_GROUP_ID),
  SIZE_5INCH_ID: Number(process.env.REACT_APP_CC_SIZE_5INCH_ID),
  SIZE_6INCH_ID: Number(process.env.REACT_APP_CC_SIZE_6INCH_ID),
  SIZE_8INCH_ID: Number(process.env.REACT_APP_CC_SIZE_8INCH_ID),
  SIZE_10INCH_ID: Number(process.env.REACT_APP_CC_SIZE_10INCH_ID),
  SHAPE_SQUARE_ID: Number(process.env.REACT_APP_CC_SHAPE_SQUARE_ID),
  SHAPE_ROUND_ID: Number(process.env.REACT_APP_CC_SHAPE_ROUND_ID),
  SHAPE_HEART_ID: Number(process.env.REACT_APP_CC_SHAPE_HEART_ID),
  FLAVOR_CHOCOLATE_ID: Number(process.env.REACT_APP_CC_FLAVOR_CHOCOLATE_ID),
  FLAVOR_STRAWBERRY_ID: Number(process.env.REACT_APP_CC_FLAVOR_STRAWBERRY_ID),
  D3_0SHAPE_ID: Number(process.env.REACT_APP_CC_3D_0SHAPE_ID),
  D3_1SHAPE_ID: Number(process.env.REACT_APP_CC_3D_1SHAPE_ID),
  D3_2SHAPE_ID: Number(process.env.REACT_APP_CC_3D_2SHAPE_ID),
  D3_3SHAPE_ID: Number(process.env.REACT_APP_CC_3D_3SHAPE_ID),
  GLITTER_GOLDEN_ID: Number(process.env.REACT_APP_CC_GLITTER_GOLDEN_ID),
  GLITTER_SILVER_ID: Number(process.env.REACT_APP_CC_GLITTER_SILVER_ID),
  RIBBON_NO_ID: Number(process.env.REACT_APP_CC_RIBBON_NO_ID),
  RIBBON_1PC_ID: Number(process.env.REACT_APP_CC_RIBBON_1PC_ID),
  RIBBON_2PC_ID: Number(process.env.REACT_APP_CC_RIBBON_2PC_ID),
  RIBBON_3PC_ID: Number(process.env.REACT_APP_CC_RIBBON_3PC_ID),
  RIBBON_4PC_ID: Number(process.env.REACT_APP_CC_RIBBON_4PC_ID),
  MESSAGE_PRINTING_ID: Number(process.env.REACT_APP_CC_MESSAGE_PRINTING_ID),
};

export default CUSTOM_CAKE_IDS;